interface ColorType {
  [key: string]: {
    color: string;
    icon: string;
  };
}

export const colorsTypes: ColorType = {
  normal: {
    color: "#aab09f",
    icon: "/assets/pokemonTypes/normal.svg",
  },
  fire: {
    color: "#ee8130",
    icon: "/assets/pokemonTypes/fire.svg",
  },
  fighting: {
    color: "#cb5f48",
    icon: "/assets/pokemonTypes/fighting.svg",
  },
  water: {
    color: "#6390f0",
    icon: "/assets/pokemonTypes/water.svg",
  },
  poison: {
    color: "#a33ea1",
    icon: "/assets/pokemonTypes/poison.svg",
  },
  electric: {
    color: "#f7d02c",
    icon: "/assets/pokemonTypes/electric.svg",
  },
  ground: {
    color: "#e2bf65",
    icon: "/assets/pokemonTypes/ground.svg",
  },
  grass: {
    color: "#7ac74c",
    icon: "/assets/pokemonTypes/grass.svg",
  },
  flying: {
    color: "#7da6de",
    icon: "/assets/pokemonTypes/flying.svg",
  },
  ice: {
    color: "#96d9d6",
    icon: "/assets/pokemonTypes/ice.svg",
  },
  bug: {
    color: "#a6b91a",
    icon: "/assets/pokemonTypes/bug.svg",
  },
  psychic: {
    color: "#f95587",
    icon: "/assets/pokemonTypes/psychic.svg",
  },
  rock: {
    color: "#b6a136",
    icon: "/assets/pokemonTypes/rock.svg",
  },
  dragon: {
    color: "#6a7baf",
    icon: "/assets/pokemonTypes/dragon.svg",
  },
  ghost: {
    color: "#735797",
    icon: "/assets/pokemonTypes/ghost.svg",
  },
  dark: {
    color: "#736c75",
    icon: "/assets/pokemonTypes/dark.svg",
  },
  steel: {
    color: "#89a1b0",
    icon: "/assets/pokemonTypes/steel.svg",
  },
  fairy: {
    color: "#d685ad",
    icon: "/assets/pokemonTypes/fairy.svg",
  },
};
